import React, { Component } from 'react';

import '../css/fragment.css';

import { capitalize } from '../util/string';

export default class ApiTab extends Component {
    setVariable(variable, value) {
        this.setState({ [variable]: value });
    }

    valueLink = (variable, isGeneric) => ({
        [`onSelect${isGeneric ? '' : capitalize(variable)}`]: value => this.setVariable(variable, value),
        [isGeneric ? 'value' : variable]: this.state[variable],
    })

    renderTitle = () => {
        throw new Error('renderTitle must be defined!', this);
    }

    renderLeft = () => {
        throw new Error('renderLeft must be defined!', this);
    }

    renderRight = () => {
        throw new Error('renderRight must be defined!', this);
    }

    render() {
        return (
            <div className='rendered-fragment'>
                <div className='rendered-fragment__title'>
                    {this.renderTitle()}
                </div>
                <div className='rendered-fragment__body'>
                    <div className='rendered-fragment__controls'>
                        {this.renderLeft()}
                    </div>
                    <div className='rendered-fragment__preview'>
                        {this.renderRight()}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ApiTab.jsx